module.exports = __webpack_public_path__ + "img/41a4c8c.png";